import { useMutation } from "@tanstack/react-query";
import { Api, type UpdateUserPasswordRequest } from "@/api";
import { usersKeys } from "./keys";

type UpdateUserPasswordInput = UpdateUserPasswordRequest & { id: string };

/** Устанавливает новый пароль пользователя из админки. */
export const useUpdateUserPassword = () => {
	const mutation = useMutation({
		mutationFn: ({ id, password }: UpdateUserPasswordInput) =>
			Api.User.putApiUsersPasswordById({ id }, { password }),
		mutationKey: usersKeys.updatePassword,
	});
	return { execute: mutation.mutateAsync, isPending: mutation.isPending };
};
